import React from "react";
import List from "@mui/material/List";
import NavItem from "../helpers/NavItem";

const ProfileNavBar = ({
  onNavItemClicked = () => null,
}) => {
  return (
    <List>
      <NavItem
        labelText="General"
        to="./"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Settings"
        to="./settings"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Password"
        to="./password"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Contact"
        to="./contact"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Bio"
        to="./bio"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Emails"
        to="./emails"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Socials"
        to="./socials"
        onNavItemClicked={onNavItemClicked}
      />
      <NavItem
        labelText="Image"
        to="./image"
        onNavItemClicked={onNavItemClicked}
      />
    </List>
  );
};

export default ProfileNavBar;